var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVenezuela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 16,
    fill: "none",
    viewBox: "0 0 24 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24-.003H0v15.998h24V-.003z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 4.52H0v6.96h24V4.52z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M17.22 9.403l-.383.292.166.45-.398-.27-.375.293.135-.458-.397-.27.48-.015.127-.457.165.45.48-.015zm-.967-1.673l-.255.405.307.368-.457-.12-.256.405-.037-.473-.457-.12.442-.18-.037-.472.307.367.443-.18zm-1.478-1.237l-.098.465.413.24-.473.045-.097.472-.195-.435-.48.045.36-.315-.195-.442.412.24.353-.315zm-1.808-.66l.068.472.465.083-.428.21.068.472-.33-.345-.435.21.225-.42-.33-.345.473.083.224-.42zm-1.927 0l.225.42.465-.083-.33.345.225.42-.428-.21-.337.345.068-.472-.428-.21.473-.083.067-.472zm-1.815.66l.353.315.412-.24-.195.442.36.315-.48-.045-.187.435-.105-.472-.473-.045.413-.24-.098-.465zM7.748 7.73l.442.18.308-.367-.03.472.442.18-.465.12-.037.473-.248-.405-.465.12.308-.368-.255-.405zM6.78 9.403l.48.015.165-.45.128.457.48.015-.398.27.135.457-.375-.292-.397.27.165-.45-.383-.292z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M24-.003H0V4.52h24V-.003z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVenezuela);
export default __webpack_public_path__ + "static/media/Venezuela.d917f0c19e430b524f641dd4cde6ae64.svg";
export { ForwardRef as ReactComponent };